<template>
  <div class="pageBox">
    <div class="page_top">
      <div class="top_phone" @click="$router.push('/apply')">17834477751</div>
    </div>
    <div class="page_content">
      <div class="list_box">
        <div class="box_title">
          <img src="../../assets/img/icons/ybmIcon.png" />
          已报名
        </div>
        <div class="list_item">
          <div class="item_top">
            <p>xxxxxxxxx招聘会</p>
          </div>
          <div class="item_center">
            <div class="job_info">
              <div>前端工程师</div>
              <div>1000-20000 元</div>
            </div>
            <p>报名时间：2022-10-20 至 2022-10-23</p>
            <p>召开时间：2022-10-20 至 2022-10-23</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Person",
  data() {
    return {};
  },
};
</script>

<style scoped>
.pageBox {
  background: linear-gradient(230deg, #b8d8ff, #e6f2fa, #f4f8fb);
}

.page_top {
  padding: 20px;
}

.top_phone {
  font-size: 20px;
}

.page_content {
  padding: 20px;
}
.box_title{
  display: flex;
  align-items: center;
  font-size: 18px;
  color: rgb(79 181 253);
  font-weight: 600;
  padding-bottom: 5px;
}
.box_title img{
  width: 26px;
  height: 26px;
  padding-right: 5px;
}

.list_box {
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
}

.list_item {
  padding: 10px 0;
  padding-right: 10px;
  border-bottom: 1px solid #e3e3e3;
}

.item_top {
  font-size: 17px;
  font-weight: bold;
}
.job_info{
  display: flex;
  justify-content: space-between;

}
.item_center {
  padding-top: 10px;
  line-height: 26px;
  font-size: 16px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/views/Person/Person.vue